import React from 'react';
import { Switch, Redirect } from 'react-router-dom';

import { RouteWithLayout } from './components';
import { Main as MainLayout, Minimal as MinimalLayout } from './layouts';

import Cookies from 'universal-cookie'

import {
  MyOffers as MyOffersView,
  ProductList as ProductListView,
  Offers as OfferView,
  UnvalidatedOffers as UnvalidatedOffersView,
  UserList as UserListView,
  Dashboard as DashboardView,
  Account as AccountView,
  Settings as SettingsView,
  SignUp as SignUpView,
  SignIn as SignInView,
  NotFound as NotFoundView,
  Activation as ActivationView,
  NewOffer as NewOfferView,
  AdditionalInfo as AdditionalInfoView,
  OfferDetails as OfferDetailsView,
  ComingSoon as ComingSoonView,
  ViewProfiles as ViewProfilesView,
  MyApplications as MyApplicationsView,
  Beta as BetaView,
  PendingVerification as PendingVerificationView,
  Favorites as FavoritesView,
} from './views';

const cookies = new Cookies();

const PrivateRoute = ({ component: Component, layout: Layout, path: path, ...rest }) => (  
  cookies.get('auth')
  ? <RouteWithLayout
      component={Component}
      exact
      layout={Layout}
      path={path}
    />
  : <Redirect
      to="/sign-in"
    />
)

const AlumniOnlyRoute = ({ component: Component, layout: Layout, path: path, ...rest }) => (
  cookies.get('isAlumni') === "true"
    ? <RouteWithLayout
      component={Component}
      exact
      layout={Layout}
      path={path}
    />
    : <Redirect
      to="/offers"
    />
)

const AdminOnlyRoute = ({ component: Component, layout: Layout, path: path, ...rest }) => (
  cookies.get('isAdmin') === "true"
    ? <RouteWithLayout
      component={Component}
      exact
      layout={Layout}
      path={path}
    />
    : <Redirect
      to="/offers"
    />
)

const SpecialoAuth = ({ component: Component, layout: Layout, path: path, location: location, ...rest }) => (
  (location.state)
  ? <RouteWithLayout
      component={Component}
      exact
      layout={Layout}
      path={path}
    />
  : <Redirect
      to="/sign-in"
    />
)


const Routes = () => {
  return (
    <Switch>
      <Redirect
        exact
        from="/"
        to="/sign-in"
      />
      <AdminOnlyRoute
        component={DashboardView}
        exact
        layout={MainLayout}
        path="/admin"
      />
      <AdminOnlyRoute
        component={UnvalidatedOffersView}
        exact
        layout={MainLayout}
        path="/unvalidated-offers"
      />
      <RouteWithLayout
        component={OfferView}
        exact
        layout={MainLayout}
        path="/offers"
      />
      <PrivateRoute
        component={MyApplicationsView}
        exact
        layout={MainLayout}
        path="/my-applications"
      />
      <PrivateRoute
        component={OfferDetailsView}
        exact
        layout={MainLayout}
        path="/offers/:id"
      />
      <PrivateRoute
        component={FavoritesView}
        exact
        layout={MainLayout}
        path="/favorites"
      />
      <AlumniOnlyRoute
        component={MyOffersView}
        exact
        layout={MainLayout}
        path="/my-offers"
      />
      <AlumniOnlyRoute
        component={UserListView}
        exact
        layout={MainLayout}
        path="/seekers"
      />
      <AlumniOnlyRoute
        component={ViewProfilesView}
        exact
        layout={MainLayout}
        path="/View-profiles"
      />
      <PrivateRoute
        component={AccountView}
        exact
        layout={MainLayout}
        path="/account"
      />
      <PrivateRoute
        component={SettingsView}
        exact
        layout={MainLayout}
        path="/settings"
      />
      <PrivateRoute
        component={ComingSoonView}
        exact
        layout={MainLayout}
        path="/soon"
      />
      <AlumniOnlyRoute
        component={NewOfferView}
        exact
        layout={MainLayout}
        path="/my-offers/new"
      />
      <RouteWithLayout
        component={SignUpView}
        exact
        layout={MinimalLayout}
        path="/sign-up"
      />
      <RouteWithLayout
        component={ActivationView}
        exact
        layout={MinimalLayout}
        path="/activation"
      />
      <RouteWithLayout
        component={SignInView}
        exact
        layout={MinimalLayout}
        path="/sign-in"
      />
      <RouteWithLayout
        component={NotFoundView}
        exact
        layout={MinimalLayout}
        path="/not-found"
      />
      <SpecialoAuth
        component={AdditionalInfoView}
        exact
        layout={MinimalLayout}
        path="/additional"
      />
      <RouteWithLayout
        component={BetaView}
        exact
        layout={MinimalLayout}
        path="/beta"
      />
      <RouteWithLayout
        component={PendingVerificationView}
        exact
        layout={MinimalLayout}
        path="/pending-verification"
      />
      <Redirect to="/not-found" />
    </Switch>
  );
};

export default Routes;
